const CHANNEL = 'epik-device-swap';
const STORAGE_KEY = 'epikDeviceSwapStatus';

export function publishDeviceSwapStatus(payload) {
  const data = { ...payload, ts: Date.now() };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (err) {
    /* ignore quota / private mode */
  }
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      const channel = new BroadcastChannel(CHANNEL);
      channel.postMessage(data);
      channel.close();
    }
  } catch (err) {
    /* ignore */
  }
}

export function subscribeDeviceSwapStatus(handler) {
  let channel;
  const onMessage = event => handler(event.data);
  const onStorage = event => {
    if (event.key !== STORAGE_KEY || !event.newValue) return;
    try {
      handler(JSON.parse(event.newValue));
    } catch (err) {
      /* ignore */
    }
  };
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      channel = new BroadcastChannel(CHANNEL);
      channel.onmessage = onMessage;
    }
  } catch (err) {
    /* ignore */
  }
  window.addEventListener('storage', onStorage);
  return () => {
    if (channel) channel.close();
    window.removeEventListener('storage', onStorage);
  };
}

export function swapStatusMatchesBox(boxSerial, status) {
  if (!status || !boxSerial) return false;
  return status.sourceSerial === boxSerial || status.destSerial === boxSerial;
}

export function partnerSerialForBox(boxSerial, status) {
  if (!status || !boxSerial) return null;
  if (status.sourceSerial === boxSerial) return status.destSerial || null;
  if (status.destSerial === boxSerial) return status.sourceSerial || null;
  return null;
}
